module.exports = __webpack_public_path__ + "img/about-us-title.b671ec8c.svg";